import { BaseEntity } from '../base-entity';
import { CardBrandType } from '../students/credit-card-tokens/credit-card-token-entity';

export enum CreditCardClearanceStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
}

export enum Currency {
  ILS = 'ILS',
  USD = 'USD',
}

export enum CreditCardClearanceType {
  REGULAR = 'regular',
  INSTALLMENT = 'installment',
}

export interface CreditCardClearanceEntity extends BaseEntity {
  id: number;
  studentId: number;
  creditCardTokensId: number;
  creditCardClearanceStatus: CreditCardClearanceStatus;
  creditCardClearanceType: CreditCardClearanceType;
  transactionId: string;
  statusCode: string;
  gatewayResponse: Record<string, any> | null;
  amount: number;
  currency: Currency;
  updatedAt: Date;
  gatewayTransactionId: string | null;
  gatewayVoucherId: string | null;
  approvalNumber: string | null;
  cardLast4: string | null;
  cardBrand: CardBrandType | null;
}

export interface CreditCardClearanceReportEntity
  extends CreditCardClearanceEntity {
  fileUrl: string | null;
  docNumber: number | null;
}
